function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTextbtnArrow18 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h18v18H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m1420 924 4.605 4.605-4.605 4.605",
  style: {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: "1.3px"
  },
  transform: "translate(-1413.605 -919.71)"
}));
export default SvgIconTextbtnArrow18;